import {inject, Injectable} from "@angular/core";
import {Observable, take} from "rxjs";
import {removeIfNullUndefined} from "@shared/commons/transform.commons";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";

@Injectable({
    providedIn: 'root'
})
export class CompaniesApiService {

    private readonly apiServiceUrl = environment.serviceApi;
    private httpClient = inject(HttpClient);

    findAll(params: any): Observable<any> {
        params = removeIfNullUndefined(params);
        return this.httpClient.get(`${this.apiServiceUrl}/v1/companies`, {params})
            .pipe(
                take(1));
    }

    findById(id: number): Observable<any> {
        return this.httpClient.get(`${this.apiServiceUrl}/v1/companies/${id}`)
            .pipe(
                take(1));
    }

    enrich(companyId: string): Observable<any> {
        return this.httpClient.post(`${this.apiServiceUrl}/v1/companies/${companyId}/enrich`, {})
            .pipe(
                take(1));
    }

    findAllDebts(companyId: any): Observable<any> {
        return this.httpClient.get(`${this.apiServiceUrl}/v1/companies/${companyId}/pgfn-debts`)
            .pipe(
                take(1));
    }

    getNegotiationStrategy(companyId: number): Observable<any> {
        return this.httpClient.get(`${this.apiServiceUrl}/v1/companies/${companyId}/negotiation-strategy`)
            .pipe(
                take(1));
    }
}
